import { motion, useScroll } from 'framer-motion';

/** Barra fina de progresso no topo, nas cores do logo (violeta → céu). */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[5px] z-[85] origin-left rounded-r-full bg-gradient-to-r from-pet-blue via-pet-pink to-pet-peach"
      style={{ scaleX: scrollYProgress }}
    />
  );
};

export default ScrollProgress;
